import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function usePageView() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const referrer = document.referrer || '';

    fetch('/api/traffic', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path, referrer }),
    }).catch(() => {}); // fire-and-forget
  }, [location.pathname]);
}
